module.exports = __webpack_public_path__ + "static/media/finalsculpt.372a9950.jpg";